import { Component, Input, OnInit } from '@angular/core';
import { PageDataService } from 'src/app/services/page-data.service';
import { gsap, Expo, Quad } from 'gsap';

@Component({
    selector: 'app-top-promo',
    templateUrl: './top-promo.component.html',
    styleUrls: ['./top-promo.component.scss']
})
export class TopPromoComponent implements OnInit {
    @Input('isMobile') isMobile;
    selected: number = 0
    timeoutIndex: any

    constructor(
        public pageDataService: PageDataService
    ) { }

    ngOnInit(): void {
        this.loop();
        gsap.set('.TopSlider .slides', { width:  100 * (this.pageDataService.topPromos.length) + '%' });
    }

    ngOnDestroy(): void {
        clearTimeout(this.timeoutIndex);
    }

    onSelect(i: number) {
        let speed0 = !this.isMobile ? 0.8 : 0.4
        let speed1 = !this.isMobile ? 0.6 : 0.3
        let speed2 = !this.isMobile ? 1 : 0.5

        if (i != this.selected) {

            let dir = -1;
            

            gsap.to('.TopSlider .slides', speed0, { x: -i * 100 / (this.pageDataService.topPromos.length) + '%', ease: Quad.easeOut });

            // if (this.selected < i) {

            //     gsap.fromTo('.TopSlider .slides .slide:nth-child(' + (this.selected + 1) + ') ', speed1, { opacity: '1' }, { opacity: '0', ease: Quad.easeOut });
            //     // move new selected in
            //     gsap.fromTo('.HomeSlider .slides .slide:nth-child(' + (i + 1) + ') .contentWrapper', speed2, { x: '20vw', opacity: 0 }, { x: 0, opacity: 1, ease: Quad.easeOut });
            // }
            // else {
            //     gsap.fromTo('.HomeSlider .slides .slide:nth-child(' + (this.selected + 1) + ') .contentWrapper', speed1, { opacity: '1' }, { opacity: '0', ease: Quad.easeOut });
            //     // move new selected in
            //     gsap.fromTo('.HomeSlider .slides .slide:nth-child(' + (i + 1) + ') .contentWrapper', speed2, { x: '-20vw', opacity: 0 }, { x: 0, opacity: 1, ease: Quad.easeOut });

            //     // gsap.fromTo('.HomeSlider .slides .slide:nth-child(' + (i + 1) + ') .contentWrapper .tag', 0.8, {x: '-20vw', opacity: 0}, {x: 0, opacity: 1, ease: Quad.easeOut} );
            //     // gsap.fromTo('.HomeSlider .slides .slide:nth-child(' + (i + 1) + ') .contentWrapper .logoHolder', 0.8, {x: '-20vw', opacity: 0}, {x: 0, opacity: 1, ease: Quad.easeOut} );

            // }

            this.selected = i
        }
        
            this.loop()
        
    }

    next() {
        if (this.selected < this.pageDataService.topPromos.length - 1) {
            this.onSelect(this.selected + 1)
        }
        else {
            this.onSelect(0)
        }
    }

    prev() {
        if (this.selected == 0) {
            this.onSelect(this.pageDataService.topPromos.length - 1)
        }
        else {
            this.onSelect(this.selected - 1)
        }
    }

    loop() {
        clearTimeout(this.timeoutIndex);

        this.timeoutIndex = setTimeout(() => {
            this.next()

        }, 5000);
    }
}
